<template>
  <b-overlay>
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>ساخت سطح دوره جدید</h1>
          <b-form class="p-2" @submit.prevent>
            <!-- Language Persian Title -->
            <b-form-group label="نام سطح دوره" label-for="persian-title">
              <b-form-input
                id="persian-title"
                v-model="courseTypeDetails.title"
                trim
                placeholder="ابتدایی"
              />
            </b-form-group>
            <b-button variant="primary" @click="createNewCourseType"
              >ثبت</b-button
            >
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { CreateCourseType } from "../../../../libs/Api/CourseType";
export default {
  data() {
    return {
      courseTypeDetails: {
        isDeleted: false,
        title: null,
        courseTypeId: 0,
        createDate: new Date(Date.now()),
      },
    };
  },
  methods: {
    async createNewCourseType() {
      let _this = this;
      let createCourseType = new CreateCourseType(_this);
      createCourseType.setParams(_this.courseTypeDetails);
      await createCourseType.fetch(
        function (response) {
          // console.log(response);
        },
        function (error) {
          console.error(error);
        }
      );
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
